import type { ReactNode } from 'react'
import { Button, Dialog, Portal, Text } from '@chakra-ui/react'
import CustomDialogBackdrop from '@/components/CustomDialogBackdrop'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  body: ReactNode
  subtitle?: ReactNode
  onConfirm: () => void
  confirmLabel?: string
  confirmColorPalette?: string
  confirmVariant?: 'solid' | 'outline' | 'ghost' | 'subtle'
  hideCancelButton?: boolean
  isPending?: boolean
  size?: 'sm' | 'md'
}

const ConfirmActionDialog = ({
  open,
  onOpenChange,
  title,
  body,
  subtitle,
  onConfirm,
  confirmLabel = 'Confirmar',
  confirmColorPalette,
  confirmVariant = 'solid',
  hideCancelButton,
  isPending,
  size = 'sm',
}: Props) => (
  <Dialog.Root
    size={size}
    placement="center"
    open={open}
    onOpenChange={({ open }) => onOpenChange(open)}
  >
    <Portal>
      <CustomDialogBackdrop />
      <Dialog.Positioner>
        <Dialog.Content m={6}>
          <Dialog.Header>
            <Dialog.Title>{title}</Dialog.Title>
          </Dialog.Header>
          <Dialog.Body>
            <Text>{body}</Text>
            {subtitle && (
              <Text color="red.500" fontWeight="bold" mt={2}>{subtitle}</Text>
            )}
          </Dialog.Body>
          <Dialog.Footer>
            {!hideCancelButton && (
              <Button size="sm" variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
                Cancelar
              </Button>
            )}
            <Button
              size="sm"
              colorPalette={confirmColorPalette}
              variant={confirmVariant}
              onClick={onConfirm}
              loading={isPending}
            >
              {confirmLabel}
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Portal>
  </Dialog.Root>
)

export default ConfirmActionDialog
